import { Component, Input, OnInit } from '@angular/core';

import { Subject } from 'rxjs';

import { ListaResultset } from 'src/app/core/list/lista-resultset.interface';
import { ItemInventario } from '../../../item-inventario/item-inventario.model';
import { ItemInventarioService } from '../../../item-inventario/item-inventario.service';
import { IItemProdutoRetirada } from '../../../item-produto-retirada/item-produto-retirada.model';
import { IItemInventarioRetirada } from '../../model/item-inventario-retirada.interface';
import { IInventarioDTO } from './model/tabela-inventario-dto.model';
import { TabelaInventarioService } from './tabela-inventario.service';
import { ItemInventarioFilter } from '../../../componentes/seletor-de-lote/model/item-inventario.filter';




/*
  DEFINICAO dos objetos utilizados nas classes: item-retirada.metadata, tabela-inventario.component, retirada.component

  IInventarioDTO          :: DTO utilizado pela tabela-inventario.component
  ItemInventario          :: model do Item de Setor ( usado na célula LOTE da listagem de retirada ( usado no metadata ) )
  IItemInventarioRetirada :: model utilizado para montar a listagem de retirada ( usado no metadada )
*/

@Component({
  selector: 'app-tabela-inventario',
  templateUrl: './tabela-inventario.component.html',
  styleUrls: ['./tabela-inventario.component.css']
})
export class TabelaInventarioComponent implements OnInit {

  @Input() quantidadeSolicitada: number;
  itensInventario: ItemInventario[];

  quantidadeAMoverSubject: Subject<number>;
  aplicarSubject: Subject<any>;

  constructor(
    private itemInventarioService: ItemInventarioService
    , private tabelaInventarioService: TabelaInventarioService
  ) { }

  ngOnInit() {
  }

  inicializar(idUnidade: number, idProduto: number, dadosTabela: IItemProdutoRetirada[]): void {
    this.tabelaInventarioService.limpar();

    this.aplicarSubject = new Subject();
    this.quantidadeAMoverSubject = new Subject();

    setTimeout(() => {
      const quantidadeMaiorQue = 1;
      // const idProdutoFiltro = dadosTabela[0].itemProdutoRetiradaPK.produto.id;

      const filter: ItemInventarioFilter = {
        idUnidade: idUnidade,
        idProduto: idProduto,
        quantidadeMaiorQue: quantidadeMaiorQue
      };

      this.itemInventarioService
          .buscarItensInventario(filter)
          .subscribe((result: ListaResultset<ItemInventario>) => {
            this.itensInventario = result.content;

            setTimeout(() => {
              if ( dadosTabela ) {
                this.tabelaInventarioService.preCarregarTabela(dadosTabela);
              }

              const totalAMover = this.tabelaInventarioService.getTotalAMover();
              this.quantidadeAMoverSubject.next(totalAMover);
            }, 150);
          })
      }, 100);
  }

  getAplicarSubject(): Subject<any>  {
    return this.aplicarSubject;
  }

  getQuantidadeAMoverSubject(): Subject<number>  {
    return this.quantidadeAMoverSubject;
  }

  atualizarCheckboxPeloValorAMover(event: any): void {
    this.tabelaInventarioService.atualizarCheckboxPeloValorAMover(event);
  }

  getTotalAMover(event) {
    setTimeout(() => {
      const acumulado = this.tabelaInventarioService.getTotalAMover(event);
      this.quantidadeAMoverSubject.next(acumulado);
    }, 100);
  }

  atualizarValorAMover(idInventario: number, idLote: number): void {
    const itemInventarioQuantidadeOriginal = this.tabelaInventarioService.getQuantidadeHidden(idInventario, idLote);

    this.tabelaInventarioService.atualizarValorAMover(idInventario,
                                                      idLote,
                                                      itemInventarioQuantidadeOriginal,
                                                      this.quantidadeAMoverSubject,
                                                      this.quantidadeSolicitada);
  }

  clickCheckbox(idInventario: number, idLote: number): void {
    this.tabelaInventarioService.clickCheckbox(idInventario, idLote);
  }

  ngOnDestroy() {
    if ( this.aplicarSubject ) {
      this.aplicarSubject.complete();
    }

    if ( this.quantidadeAMoverSubject ) {
      this.quantidadeAMoverSubject.complete();
    }
  }

  getItensSelecionados(): IItemInventarioRetirada[] {
    return this.tabelaInventarioService.getItensSelecionados();
  }

  montaValorDaLinha(inventarioDTO:  IInventarioDTO, itemInventario: ItemInventario): IItemInventarioRetirada {
    const quantidadeAMover = this.tabelaInventarioService.getValorAMoverDoInput(inventarioDTO.id, itemInventario.lote.id);

    // TODO: CONFERIR OBJETO ABAIXO ao vir do banco a propriedade preenchida eh: itemInventarioRetiradaPK
    const o: IItemInventarioRetirada = {
      inventario: inventarioDTO,
      lote: itemInventario.lote,
      itemInventario: itemInventario,
      quantidadeRetirada: quantidadeAMover,
      itemInventarioRetiradaPK: null
    };

    return o;
  }

}
